"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAcrossPlugin = exports.acrossPlugin = void 0;
const context_1 = require("@derivation-tech/context");
const across_module_1 = require("./across.module");
const tx_plugin_1 = require("@derivation-tech/tx-plugin");
const acrossPlugin = () => {
    return {
        install(ctx) {
            ctx.across = new across_module_1.AcrossModule(ctx);
        },
    };
};
exports.acrossPlugin = acrossPlugin;
const createAcrossPlugin = (chainIdOrName, providerUrlOrWss, callOption) => {
    return new context_1.Context(chainIdOrName, providerUrlOrWss).use((0, exports.acrossPlugin)()).use((0, tx_plugin_1.txPlugin)(callOption));
};
exports.createAcrossPlugin = createAcrossPlugin;
